import React, { Component } from 'react';
import styled from '@emotion/styled';
import { ShareContactDto } from './models/dto/ShareContactDto';
import { ShareContactTransformer } from './models/transformers/ShareContactTransformer';
import { EmailContact } from './models/view/EmailContact';
import { SearchResultsDto } from './models/dto/SearchResultsDto';
import { SearchResultsTransformer } from './models/transformers/SearchResultsTransformer';

const ListPanel = styled.div`
  position: absolute;
  width: 100%;
  min-height: 30px;
  background: #fff;
  top: 73px;
  border: 2px solid #4694ce;
`;

const List = styled.ul`
  list-style: none;
  margin: 0px;
  padding: 0px 0.5rem;
  cursor: pointer;

  li {
    height: 42px;
    border-bottom: 1px solid #f2f2f2;
    padding: 0.7rem 0.3rem;

    &:hover {
      background: #f5fbff;
    }
  }
`;

const TextInput = styled.input`
  padding-left: 35px;
  height: 45px;
  border: 2px solid #bdcad2;

  &:focus {
    background-color: #f5fbff;
  }
`;

const Message = styled.span`
  padding: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
`;

interface Props {
  apiUrl?: string;
  listItemClick: (selected: string) => void;
  projectId: number;
}

interface State {
  emailList: EmailContact[];
  recentRecipientsList: EmailContact[];
  typeAheadLoading: boolean;
  showListPanel: boolean;
  showRecentRecipients: boolean;
}

class ShareInputField extends Component<Props, State> {
  state = {
    showListPanel: false,
    typeAheadLoading: false,
    emailList: [],
    showRecentRecipients: false,
    recentRecipientsList: [],
  };

  async componentDidMount() {
    const url = this.props.apiUrl
      ? `${this.props.apiUrl}/modal/ShareProjectModel?projectid=${this.props.projectId}`
      : `/modal/ShareProjectModel?projectid=${this.props.projectId}`;
    const response = await fetch(url);
    const json = (await response.json()) as ShareContactDto;
    const data = ShareContactTransformer.from(json).recentContacts;
    this.setState(state => {
      return { ...state, recentRecipientsList: data };
    });
  }

  focused = () => {
    this.setState(state => {
      return {
        ...state,
        showListPanel: true,
        showRecentRecipients: true,
        emailList: state.recentRecipientsList,
      };
    });
  };

  blur = () => {
    this.setState(state => {
      return {
        ...state,
        showListPanel: false,
      };
    });

    (this.refs.emailInput as HTMLInputElement).value = '';
  };

  keyUp = async () => {
    const value = (this.refs.emailInput as HTMLInputElement).value;
    if (!value) {
      this.setState(state => {
        return { ...state, typeAhead: [], showListPanel: false };
      });
    } else {
      const response = await fetch(
        `/modal/autocomplete/?email=${value}&isIokitUpload=null&isTeamMemberSearch=null`
      );
      const json = (await response.json()) as SearchResultsDto;
      const data = SearchResultsTransformer.from(json).emailList;
      this.setState(state => {
        return {
          ...state,
          emailList: data,
          typeAheadLoading: false,
          showListPanel: true,
          showRecentRecipients: false,
        };
      });
    }
  };

  listItemClick = (key: number) => {
    const list = this.refs.list as HTMLUListElement;
    const selected = (list.children[key] as HTMLLIElement).innerText;
    this.props.listItemClick(selected);
    (this.refs.emailInput as HTMLInputElement).value = '';
    this.setState(state => {
      return { ...state, showListPanel: false };
    });
  };

  render() {
    return (
      <>
        <TextInput
          ref="emailInput"
          type="text"
          placeholder="Enter email address"
          onKeyUp={this.keyUp}
          onFocus={this.focused}
          onBlur={this.blur}
        />

        {this.state.showListPanel && (
          <ListPanel>
            {this.state.showRecentRecipients && <Message>Recent Recipients</Message>}
            {this.state.typeAheadLoading && <Message>Searching...</Message>}
            {!this.state.typeAheadLoading && (
              <List ref="list">
                {this.state.emailList.length > 0 &&
                  this.state.emailList.map((d: EmailContact, i) => {
                    return (
                      <li
                        key={i}
                        onMouseDown={e => {
                          if (e.button === 0) this.listItemClick(i);
                        }}
                      >
                        {d.email}
                      </li>
                    );
                  })}
                {this.state.emailList.length === 0 && <Message>No Results Found</Message>}
              </List>
            )}
          </ListPanel>
        )}
      </>
    );
  }
}

export default ShareInputField;
